import { api } from "@/services/api";
import {
  Banner,
  CreateBanner,
  DeleteResponse,
  ReorderBanners,
  UpdateBanner,
  UploadedBannerImage,
} from "@/types";

export class BannerRepository {
  async findAll(): Promise<Banner[]> {
    const response = await api.get<Banner[]>("/v1/admin/banners");

    return response.data;
  }

  async uploadImage(file: File): Promise<UploadedBannerImage> {
    const formData = new FormData();

    formData.append("file", file);

    const response = await api.post<UploadedBannerImage>(
      "/v1/admin/banners/images",
      formData,
      // The shared client defaults to JSON, which would turn the form into JSON and the backend would never get a file.
      { headers: { "Content-Type": "multipart/form-data" } },
    );

    return response.data;
  }

  async add(data: CreateBanner): Promise<Banner> {
    const response = await api.post<Banner>("/v1/admin/banners", data);

    return response.data;
  }

  async update(id: string, data: UpdateBanner): Promise<Banner> {
    const response = await api.patch<Banner>(`/v1/admin/banners/${id}`, data);

    return response.data;
  }

  async reorder(data: ReorderBanners): Promise<Banner[]> {
    const response = await api.put<Banner[]>("/v1/admin/banners/order", data);

    return response.data;
  }

  async delete(id: string): Promise<DeleteResponse> {
    const response = await api.delete<DeleteResponse>(
      `/v1/admin/banners/${id}`,
    );

    return response.data;
  }
}
